/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import FormField from 'apps/FormField'
import TextareaElement from 'elements/Textarea'
import { isErrorShown, getMessageText, getFieldState } from 'utils/field'

const Textarea: React.FC<any> = ({
  input,
  meta,
  t,
  getTextPath,
  startPath,
  label,
  required,
  dispatch,
  ...restProps
}) => (
  <FormField
    isErrorShown={isErrorShown(meta)}
    errorMessage={getMessageText(meta, t)}
    label={label}
    required={required}
    showLengthCounter={restProps.showLengthCounter}
    maxLength={restProps.maxLength}
    valueLength={input.value.length}
  >
    <TextareaElement {...input} state={getFieldState(meta)} {...restProps} />
  </FormField>
)

export default Textarea
